export default __webpack_public_path__ + "static/media/torbjorn-icon.b18fb5fc.webp";